import styled, { css } from 'styled-components'
import { SuitableStates } from '../../../models/common/suitables-model'

export const FeaturesContainer = styled.div<{ gap: number }>`
    ${({ gap }) => css`
        display: flex;
        align-items: center;
        gap: 0.25rem ${gap}rem;
        flex-wrap: wrap;
    `}
`

export const FeatureWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
`

export const FeatureIconWrapper = styled.div<{ state: SuitableStates; color: string; size: number }>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    ${({ state, color, size }) => {
        switch (state) {
            case SuitableStates.SUITABLE_STATUS_NOT_ALLOWED:
                return css`
                    &::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: ${size + 0.5}rem;
                        height: 0;
                        border-top: 1px solid ${color};
                        transform: translate(-50%, -50%) rotate(-45deg);
                    }
                `
            case SuitableStates.SUITABLE_STATUS_ON_REQUEST:
                return css`
                    &::after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: ${size + 0.5}rem;
                        height: 0;
                        border-top: 2px dotted ${({ theme }) => theme.colors.tfwAlertMedium};
                        transform: translate(-50%, -50%) rotate(-45deg);
                    }
                `
            default:
                return ''
        }
    }}
`

export const FeatureIcon = styled.svg<{ color: string; size: number }>(
    ({ size, color }) => css`
        width: ${size}rem;
        height: ${size}rem;

        & > path,
        & > g,
        & > circle,
        & > rect {
            stroke: ${color};
            stroke-width: 1.5px;
        }
    `,
)

export const FeatureLabel = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.875rem;
        line-height: 1.375rem;
        margin-left: 0.25rem;
        color: #282828;
    `,
)
